import type {
  AdjustRenewalDateBody,
  GetBillingAccountOverviewResponse,
} from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import { subscriptionKeys } from "@/hooks/queryKeys";
import { dateFormatter } from "@/utils/dateFormatter";

import { adjustRenewalDate } from "../../overview/utils/account-overview-cache";

export function useAdjustRenewalDate(
  projectId: number,
): UseMutationResult<AdjustRenewalDateBody, Error, AdjustRenewalDateBody> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (adjustment: AdjustRenewalDateBody) => adjustment,
    onSuccess: ({ days }) => {
      const overview =
        queryClient.setQueryData<GetBillingAccountOverviewResponse>(
          subscriptionKeys.accountOverview(projectId),
          (current) => current && adjustRenewalDate(current, days),
        );

      toast.add({
        description: `New renewal date: ${dateFormatter(overview?.upcomingPayment.renewalDate)}.`,
        timeout: 3000,
        title: "Renewal date adjusted",
        type: "success",
      });
    },
  });
}
